import React from "react"
import PropTypes from "prop-types"
import { X } from "lucide-react"
import {
  CardHeader,
  CardTitle,
  CardContent,
  CardDescription,
  Button,
} from "ksc-portal-common-components/shadcn"
import ConfirmPasswords from "../../components/ConfirmPasswords"

const SubmitPasswordReplacement = ({
  submitReplacementPassword,
  storePasswordCriteria,
  passwordCriteria,
  backToLogin,
}) => (
  <>
    <CardHeader>
      <Button
        onClick={backToLogin}
        variant="ghost"
        size="icon"
        className="absolute right-3 top-3 rounded-full"
        aria-label="Close"
        data-testid="back-button"
      >
        <X className="h-4 w-4" />
      </Button>
      <CardTitle className="text-2xl font-medium text-foreground">
        Change Password
      </CardTitle>
      <CardDescription>Please enter your new password</CardDescription>
    </CardHeader>
    <CardContent className="space-y-4">
      <ConfirmPasswords
        passwordCriteria={passwordCriteria}
        storePasswordCriteria={storePasswordCriteria}
        enterNewPassword={submitReplacementPassword}
      />
    </CardContent>
  </>
)

SubmitPasswordReplacement.propTypes = {
  submitReplacementPassword: PropTypes.func.isRequired,
  storePasswordCriteria: PropTypes.func.isRequired,
  passwordCriteria: PropTypes.shape({
    length: PropTypes.number,
    lowerCase: PropTypes.bool,
    upperCase: PropTypes.bool,
    numbers: PropTypes.bool,
    symbols: PropTypes.bool,
  }),
  backToLogin: PropTypes.func.isRequired,
}

SubmitPasswordReplacement.defaultProps = {
  passwordCriteria: null,
}

export default SubmitPasswordReplacement
